import StyledSvg from 'icons/StyledSvg';
import { IconProps } from 'icons/types';

export const TikTok = ({ size, color, x = '0px', y = '0px', scale = 0 }: IconProps) => {
  return (
    <StyledSvg
      xmlns="http://www.w3.org/2000/svg"
      width={size || '40px'}
      height={size || '40px'}
      scale={scale || 0}
      x={x}
      y={y}
      viewBox="0 0 40 40"
      fill={color || 'currentColor'}
    >
      <path
        d="M34.138,10.758v5.809c-4.342,0-7.993-2.658-7.993-2.658v11.816c0,0.199-0.005,0.395-0.016,0.591
        c-0.307,5.625-4.976,10.091-10.691,10.091c-5.714,0-10.707-4.783-10.707-10.682c0-5.899,4.794-10.682,10.707-10.682
        c0.553,0,1.097,0.042,1.628,0.122v6.047c-0.508-0.183-1.057-0.282-1.628-0.282c-2.654,0-4.805,2.146-4.805,4.794
        c0,2.648,2.151,4.794,4.805,4.794c2.654,0,4.772-1.953,4.958-4.431l0.026,0.228V2.588h5.723
        C26.146,10.27,34.139,10.758,34.138,10.758L34.138,10.758z"
        fill={color || 'currentColor'}
      />
    </StyledSvg>
  );
};
